/* eslint-disable max-len */
export default {
  common: {
    PartI: "Parte I – Informação individual",
    PartIcontent: "Informação individual",
    PartII: "Parte II – Especificação do numerário ou instrumentos negociáveis ao portador e declaração de propriedade",
    PartIIcontent: "Especificação do numerário ou instrumentos negociáveis ao portador e declaração de propriedade",
    PartIII: "Parte III – Identificação do proprietário do numerário e/ou dos instrumentos negociáveis ao portador que não pertençam ao declarante",
    // PartIIIcontent: "Identificação do proprietário do numerário e/ou dos instrumentos negociáveis ao portador que não pertençam ao declarante",
    PartIIIcontent: "",
    PartIV: "Parte IV - Declaração",
    EntryFrom: "Entrada / Proveniência",
    or: "ou",
    ExitTo: "Saída / Destino",
    Name: "Nome",
    Gender: "Sexo",
    Nationality: "Nacionalidade",
    PlaceofBirth: "Local de nascimento",
    DateofBrith: "Data de nascimento",
    TravelDocumentType: "Tipo de documento",
    TravelDocumentNumber: "Número do documento",
    PlaceofIssue: "Local de emissão",
    Permanentaddressandtelephonecontactnumber: "Endereço de residência permanente e telefone de contacto",
    Currency: "Numerário",
    Travellerscheque: "Cheque de viagem",
    Cheque: "Cheque",
    Billofexchange: "Letra",
    MoneyOrder: "Ordem de pagamento",
    PromissoryNote: "Livrança",
    Others: "Outros",
    Currencyname: "Denominação da moeda",
    Amounttonearestwholenumber: "Montante (arredondado à unidade mais próxima)",
    Doesthedeclarantownthisitem: "Este item é propriedade do declarante",
    Yes: "Sim",
    No: "Não",
    theownershouldbeidentifiedontheappropriatefieldofPartIII: "O proprietário deve ser indicado neste item",
    LegalPersonCorporatename: "Denominação (pessoa colectiva)",
    IndividualName: "Nome (pessoa singular)",
    M: "M",
    F: "F",
    Pleaseselectenteringorleavings: "Selecione a entrada ou saída",
    tishi: "Por favor complete o perfil",
    item1: "Item 1",
    item2: "Item 2",
    item3: "Item 3",
    item4: "Item 4",
    item5: "Item 5",
    item6: "Item 6",
    item7: "Item 7",
    item8: "Item 8",
    item9: "Item 9",
    item10: "Item 10",
    item11: "Item 11",
    item12: "Item 12",
    item13: "Item 13",
    item14: "Item 14",
    item15: "Item 15",
    item16: "Item 16",
    item17: "Item 17",
    item18: "Item 18",
    item19: "Item 19",
    item20: "Item 20",
    item21: "Item 21",
    item22: "Item 22",
    item23: "Item 23",
    item24: "Item 24",
    item25: "Item 25",
    item26: "Item 26",
    item27: "Item 27",
    item28: "Item 28",
    item29: "Item 29",
    item30: "Item 30",
    details: "Preencha pelo menos 1 item e preencha no máximo 30 itens",
    required: "Conteúdo requerido",
    del: "Deletar",
    add: "Adicionar a",
    placeholder: "Por favor, insira o conteúdo",
    Address: "Sede da pessoa colectiva/ Endereço de residência permanente da pessoa singular",
    // 剩下為電腦翻譯
    Thesavewassuccessful: "O salvamento foi bem sucedido",
    Pleasemakesuretoreadthedeclaration: "Por favor, certifique-se de ler a declaração",
    Youcansaveuptotenrecords: "Podes guardar até dez discos",
    Pleasechoosetodeletetheitem: "Por favor, opte por apagar o artigo",
    Whethertoconfirmthedeletion: "Se confirmar a eliminação",
    yyyyMMdd: "yyyy ano MM mês dd dia",
    YearMonthDay: "(Ano/Mês/Dia)",
    Pleaseselect: "Selecione (suporta a recuperação direta da palavra-chave de entrada)",
    Pleaseenteryourcontactnumber: "Introduza o seu número de contacto",
    Cannotseeclearly: "Não consegue ver claramente? Mude-o",
    Keepthefilinginformation: "Guarde a informação de arquivamento nesta máquina para a próxima re-declaração",
    Ideclare: "Declaro que li o Aviso de Declaração e que as informações preenchidas são verdadeiras e completas",
    verificationcode: "Por favor, pressione o ícone para introduzir o código de verificação",
    pleasekeepthisQRcode: "Preciso de manter este código QR na alfândega, para mostrar ao oficial da alfândega este código para testes e verificação, por favor, mantenha este código QR, de modo a não trazer inconvenientes para as suas próprias viagens",
    QRcodepicturesarerequired: "As imagens de código QR são necessárias para o desalfandegamento, por favor confirme guardar localmente ou tirar fotos para guardar para o seu telefone. Confirme que o ponto de fecho ainda sai, volte a guardar por favor clique na imagem",
    Savethepicture: "Salve a foto",
    Stillexit: "Ainda sai",
    Statement: "Uma declaração",
    Pleaseentertheareacode: "Por favor, insira o código de área",
    Pleaseenterthefirstitem: "Introduza o primeiro item",
    Pleaseamount1: "Introduza a quantidade de artigo 1 da Parte Dois",
    Pleaseamount2: "Introduza a quantidade de artigo 2 da Parte Dois",
    Pleaseamount3: "Introduza a quantidade de artigo 3 da Parte Dois",
    Pleasecurrency1: "Insira o nome da moeda do ponto 1 da Parte Dois",
    Pleasecurrency2: "Insira o nome da moeda do ponto 2 da Parte Dois",
    Pleasecurrency3: "Insira o nome da moeda do ponto 3 da Parte Dois",
    Pleasewhether1: "Por favor, insira se o item 1 da Parte Dois pertence ao declarador",
    Pleasewhether2: "Por favor, insira se o item 2 da Parte Dois pertence ao declarador",
    Pleasewhether3: "Por favor, insira se o item 3 da Parte Dois pertence ao declarador",
    Pleasecurrencytype1: "Introduza a segunda parte, item 1 tipo de moeda",
    Pleasecurrencytype2: "Introduza a segunda parte, item 2 tipo de moeda",
    Pleasecurrencytype3: "Introduza a segunda parte, item 3 tipo de moeda",
    PleasePartIII1: "Introduzir a parte III Item 1",
    PleasePartIII2: "Introduzir a parte III Item 2",
    PleasePartIII3: "Introduzir a parte III Item 3",
    PleasePartpersonIII1: "Introduza o nome da pessoa singular/pessoa singular 1 na parte III",
    PleasePartpersonIII2: "Introduza o nome da pessoa singular/pessoa singular 2 na parte III",
    PleasePartpersonIII3: "Introduza o nome da pessoa singular/pessoa singular 3 na parte III",
    PleasePartaddressIII1: "Introduza o endereço de residência permanente do ponto 1 da parte III",
    PleasePartaddressIII2: "Introduza o endereço de residência permanente do ponto 2 da parte III",
    PleasePartaddressIII3: "Introduza o endereço de residência permanente do ponto 3 da parte III",
    Pleaseentertheverificationcode: "Introduza o código de verificação",
    Personaldata: "Por favor, certifique-se de ler a declaração",
    Whethertoconfirmtheremoval: "Se confirmar a remoção？",
    Thedeletionwassuccessful: "A supressão foi um sucesso",
    Is: "É",
    Save: "Salvar",
    Cancel: "Cancelar",
    Areyousure: "Tens a certeza",
    Code: "O código",
    aboutus: "Quem somos",
    Contactus: "Contacte-nos",
    Useandprivacypolicy: "Política de uso e privacidade",
    Addthenextitem: "Add",
    Pleaseenteryourplaceofentry: "Por favor, entre no seu local de entrada",
    Pleaseenteryourexitdestination: "Por favor, entre no seu destino de saída",
    Pleaseenteryourname: "Por favor, insira o seu nome",
    Pleaseenteryournationality: "Por favor, insira a sua nacionalidade",
    Pleaseenteryourplaceofbirth: "Por favor, entre no seu local de nascimento",
    Pleaseselectyourdateofbirth: "Por favor, selecione a data de nascimento",
    Pleaseselectyourdocumentcategory: "Por favor, selecione a sua categoria de documento",
    PleaseenteryourIDnumber: "Por favor, insira o seu número de identificação",
    Pleaseenteryourplaceofissue: "Por favor, entre no seu local de emissão",
    Pleaseenteryourpermanentresidenceaddress: "Por favor, insira o seu endereço de residência permanente",
    Pleaseenteryourareacode: "Por favor, insira o seu código de área",
    Pleaseselectthecurrencytype: "Por favor, selecione o tipo de moeda",
    Pleaseenter: "Por favor, entre",
    Pleaseselectyourcurrencyname: "Por favor, selecione o seu nome de moeda",
    Pleaseentertheamount: "Introduza o valor (mais próximo do inteiro)",
    Pleaseenterthepermanentresidenceaddressofthelegalentitynaturalperson: "Por favor, insira o endereço de residência permanente da entidade jurídica/pessoa singular",
    Pleasepresstheicontoentertheverificationcode: "Por favor, pressione o ícone para introduzir o código de verificação",
    Delete: "Apague",
    Pleaseselectenteringorleaving: "Por favor, selecione se está a entrar ou a sair do país",
    Immigration: "Entrada / Proveniência",
    Exit: "Saída / Destino",
    Permanentresidenceaddress: "Morada de residência permanente",
    Contactnumber: "Número de contacto",
    Stepup: "Um passo à altura",
    Nextstep: "Próxima Etapa",
    Submit: "A saída",
    Whatyouneedtoknowtodeclare: "O que precisa de saber para declarar",
    Thesubmissionwassuccessful: "A submissão foi um sucesso",
    Pleaseselectthefiler: "Ou opte por declarar registros",
    Declare: "Declarar",
    Tips: "As gorjetas",
    Carryingcashandnameless: "Transporte Transfronteiriço de Numerário e de Instrumentos Negociáveis ao Portador",
    OK: "OK",
    Close: "Perto",
    CustomsoftheMacaoSpecialAdministrativeRegion: "Alfândega da Região Administrativa Especial de Macau",
    AddressMacau: "Edifício de Comando dos Serviços de Alfândega da RAEM, sito na Avenida do Cais de Pac On Travessa Três do Cais de Pac On, Taipa",
    Email: "E-mail",
    Phone: "Telefone",
    Fax: "Fax",
    Carrycashandnamelessnegotiableinstruments: "Transportar dinheiro e instrumentos negociáveis sem nome",
    Declarationofentryandexit: "Declaração de entrada e saída",
    Declarationofentryandexitwithcashandnamelessnegotiableinstruments: "Declaração de entrada e saída com dinheiro e instrumentos negociáveis sem nome",
    Reset: "Reiniciar",
    Filer: "O Filer",
    saveCode: " SaveCode",
    edit: "Declarar novamente",
    Declares: "Declarar novamente",
    efficacy: "lost efficacy ",
    amount: "Please fill in the amount",
    confirmDelete: "Confirmar exclusão",
    warn: "Aviso",
    confirm: "Confirmar",
    cancel: "Cancelar",
    failureCode: "O código QR expirou",
    synchronizationText: "Igual ao primeiro item",
    cancelSynchronizationText: "Cancelar",
    Themainresponsibilities: "As principais responsabilidades",
    submitL: "Apresentação",
    2020: "Direitos aduaneiros de Macau de 2020",
    rujin: "Por favor, preencha a origem ou destino",
    names: "Por favor, preencha seu nome",
    Genders: "Por favor selecione um gênero",
    Nationalitys: "Selecione a nacionalidade",
    birthplaces: "Por favor, preencha o local de nascimento",
    birthTimes: "Selecione a data de nascimento",
    documentTypes: "Selecione a categoria do certificado",
    documentNums: "Por favor, preencha o número de identificação",
    issues: "Por favor, preencha o local do problema",
    addresss: "Por favor, preencha seu endereço de residência permanente",
    phones: "Por favor preencha o número de telefone",
    tis: "Selecione as informações do registro"
  }
};